export const StorageKeys = {
  token: "LABOSHOP_PORTAL_TOKEN",
  userContext: "LABOSHOP_PORTAL_USER"
};